import {
  cruiseCabinCategoryMessages,
  cruiseSearchGlossaryMessages,
} from 'constants/cruise'

/**
 * Cruise cabin categories and cruise-type labels — `docs/product-taxonomy.md` §8.
 * Cabin copy aligns with `useCruiseCabinTypeLabels` message ids; browse-all-offers live in `commonMessages`.
 */
const cruiseGlossaryMessages = {
  cabinInside: cruiseCabinCategoryMessages.inside,
  cabinOceanview: cruiseCabinCategoryMessages.oceanview,
  cabinWindow: cruiseCabinCategoryMessages.window,
  cabinBalcony: cruiseCabinCategoryMessages.balcony,
  cabinSuite: cruiseCabinCategoryMessages.suite,
  oceanviewOrWindow: cruiseCabinCategoryMessages.oceanviewOrWindow,
  oceanCruise: cruiseSearchGlossaryMessages.oceanCruise,
  riverCruise: cruiseSearchGlossaryMessages.riverCruise,
  allCruiseLines: cruiseSearchGlossaryMessages.allCruiseLines,
  allDeparturePorts: cruiseSearchGlossaryMessages.allDeparturePorts,
}

export default cruiseGlossaryMessages
